import {mapActions, mapGetters} from 'vuex'
import _ from "lodash"
import {getCurrentInstance} from "vue";

export default {
    data() {
        return {
            urlFilter: {
                enabled: true,
                hiddenParams: []
            },

            checkedRows: [],
            selected: {},

            filters: {},
            hiddenFilters: [],

            table: {
                bordered: false,
                striped: true,
                narrowed: false,
                checkable: true,
                mobileCards: true,
                paginated: true,
                paginationSimple: false,
                perPage: 10,
                defaultSortDirection: 'desc',
                defaultSort: ['id', 'desc']
            },

            isTableSettingsModalActive: false,
            isTableVisible: false,
            tableName: null,
            loading: false,
            total: 0,
            currentPage: 1,
            requestParams: {},

            itemsIds: [],
            paginatedData: [],
        }
    },

    beforeMount() {
        this.extractQueryFilters(this.$route.query)
    },

    watch: {
        appIsHydrated() {
            this.isTableVisible = true
        },

        tableColumns() {
            this.rerenderTable()
        },

        filters: {
            handler() {
                this.updateQueryFilters()
            },

            deep: true
        },
    },

    computed: {
        ...mapGetters([
            'appIsHydrated',
            'tableColumnsBySlug',
        ]),

        tableColumns() {
            return this.tableColumnsBySlug(this.tableName)
        },

        hasCheckedRows() {
            return this.checkedRows && this.checkedRows.length ? this.checkedRows.length : 0
        },

        isDeleteSelectedButtonVisible() {
            return this.checkedRows && this.checkedRows.length ? this.checkedRows.length : 0
        },

        tableSettings() {
            const tableSettings = this.tableSettingsBySlug(this.tableName)
            return tableSettings ? tableSettings : {}
        },

        isResetFiltersButtonVisible() {
            for (let field in this.visibleFilters) {
                if (this.visibleFilters[field]) {
                    return true
                }
            }

            return false
        },

        urlFilterEnabled() {
            return this.urlFilter.enabled
        },

        visibleFilters() {
            let res = _.clone(this.filters)

            _.each(this.hiddenFilters, hiddenFilter => {
                delete res[hiddenFilter]
            })

            return res
        }
    },

    mounted() {
        this.isTableVisible = !!this.appIsHydrated
    },

    methods: {
        ...mapActions(['fetchTableSettings']),
        hasColumn(field) {
            return _.find(this.tableColumns, {field}) !== undefined
        },

        rerenderTable() {
            this.isTableVisible = false

            this.$nextTick(() => this.isTableVisible = true)
        },

        clearSelected() {
            this.selected = {}
        },

        clearCheckedRows() {
            this.checkedRows = []
        },

        extractQueryFilters(queryFilters) {
            if (!this.urlFilterEnabled) {
                return
            }

            for (let filterName in queryFilters) {
                this.filters[filterName] = queryFilters[filterName];
            }
        },

        updateQueryFilters() {
            if (!this.urlFilterEnabled) {
                return
            }

            this.$router.replace({query: _.pickBy(this.visibleFilters, _.identity)})
        },

        resetFilters() {
            for (let field in this.visibleFilters) {
                this.filters[field] = _.isArray(this.filters[field]) ? [] : ''
            }

            if (this.table.paginated) {
                this.fetchPaginatedData(true, this.requestParams)
            }
        },

        onPageChange(page) {
            this.currentPage = page
            this.fetchPaginatedData(false, this.requestParams)
        },

        onSort(field, order) {
            this.clearCheckedRows()
            this.table.defaultSort = [field, order]
            this.fetchPaginatedData(false, this.requestParams)
        },

        fetchPaginatedData(resetPage = true, params = {}) {
            this.loading = true

            if (resetPage) {
                this.currentPage = 1
            }

            return this.fetchData({
                ...this.filters,
                ...params,

                paginated: this.table.paginated || null,
                page: this.currentPage,
                per_page: this.table.perPage,
                sort_field: this.table.defaultSort[0],
                sort_direction: this.table.defaultSort[1],
            }).then(res => {
                this.itemsIds = _.map(res.data.data, 'id')
                this.paginatedData = res.data.data
                this.loading = false
                const pagination = res.data.pagination
                if (!!pagination) {
                    this.total = pagination.total
                }
                return res
            })
        },

        confirmCustomDelete(
            item = null,
            redirectRouteName = null,
            title = 'Are you sure?',
            description = 'This action cannot be undone',
            buttonCaption = 'Yes'
        ) {
            this.confirmMessage(
                title, description, buttonCaption
            ).then(() => {
                if (this.checkedRows.length) {
                    let promises = []

                    this.checkedRows.forEach(item => {
                        promises.push(this.removeItem(item))
                    })

                    Promise.all(promises).then(() => {
                        this.successMessage('Deletion successfull')
                        this.checkedRows = []
                    })
                } else {
                    this.removeItem(item).then(res => {
                        this.$router.replace({name: redirectRouteName})
                        this.successMessage('Deletion successfull')
                        return res
                    })
                }
            })
        }
    }
}
